var configBuild = require('../../../config/' + CONFIG_NAME)({});

module.exports = {
  env: {
    devOrStaging: process.env.NODE_ENV === 'development' || window.location.hostname === 'hu-staging.be',
  },

  build: configBuild,

  host: 'healthunlocked.com',

  sdk: {
    url: 'https://healthunlocked.com/bg/widget',
  },

  cdn: {
    img: configBuild.imagesPath,
    postImg: configBuild.imagesPath + '/post/post_',
    communityLogos: configBuild.imagesPath + '/group-logos/',
    communityBanners: configBuild.imagesPath + '/group-banners/',
    avatars: configBuild.imagesPath + '/avatars/',
    emoji: configBuild.assetPath + '/betelgeuse/img/emoji/unicode/',
    smiley: configBuild.assetPath + '/aurora/images/smiley/',
    resourcesIndex: configBuild.assetPath + '/betelgeuse/img/index-pages/resources/',
    programsIndex: configBuild.assetPath + '/betelgeuse/img/index-pages/programs/',
  },

  avatars: {
    smallSuffix: '_small@2x_100x100.jpg',
  },

  groups: {
    bannerSuffix: '_1170x250.jpg',
    suffix: '_140x140.jpg',
  },

  guides: {

    guideline: {
      en: 'https://support.healthunlocked.com/article/11-community-guidelines',
      es: 'https://support.healthunlocked.com/article/11-community-guidelines',
      pt: 'https://support.healthunlocked.com/article/11-community-guidelines',
    },

    founders: {
      en: configBuild.assetPath + '/betelgeuse/admins/guides-en/getting-started-guide-uk.pdf',
      pt: configBuild.assetPath + '/betelgeuse/admins/guides-en/getting-started-guide-uk.pdf',
      es: configBuild.assetPath + '/betelgeuse/admins/guides-en/getting-started-guide-uk.pdf',
    },

    pioneers: {
      en: configBuild.assetPath + '/betelgeuse/admins/guides-en/Pioneers-Guide.pdf',
      pt: configBuild.assetPath + '/betelgeuse/admins/guides-pt/pioneiros-guia.pdf',
      es: configBuild.assetPath + '/betelgeuse/admins/guides-es/pioneros-guia.pdf',

    },

    problematic: {
      en: configBuild.assetPath + '/betelgeuse/admins/guides-en/moderation-guide-uk.pdf',
      pt: configBuild.assetPath + '/betelgeuse/admins/guides-en/moderation-guide-uk.pdf',
      es: configBuild.assetPath + '/betelgeuse/admins/guides-en/moderation-guide-uk.pdf',
    },

    risky: {
      en: configBuild.assetPath + '/betelgeuse/admins/guides-en/high-risk-content-uk.pdf',
      pt: configBuild.assetPath + '/betelgeuse/admins/guides-en/high-risk-content-uk.pdf',
      es: configBuild.assetPath + '/betelgeuse/admins/guides-en/high-risk-content-uk.pdf',
    },
  },

  admin: {
    welcomeMessage: {
      minChars: 100,
      maxChars: 950,
      // For the lengthStatusBars
      shortMax: 200,
      goodMax: 400,
    },
    campaignImage: {
      minWidth: 378,
      minHeight: 378,
      maxFileSize: 10,
    },
  },

  community: {
    en: {
      support: 'https://support.healthunlocked.com',
      fb: 'https://www.facebook.com/healthunlocked',
      twitter: 'https://twitter.com/healthunlocked',
      lockPost: 'https://support.healthunlocked.com/article/36-turn-off-replying-on-posts',
    },
    es: {
      support: 'https://support.healthunlocked.com',
      fb: 'https://www.facebook.com/huespanol',
      twitter: 'https://twitter.com/huespanol',
      lockPost: 'https://support.healthunlocked.com/article/36-turn-off-replying-on-posts',
    },
    pt: {
      support: 'https://support.healthunlocked.com',
      fb: 'https://www.facebook.com/huportugues',
      twitter: 'https://twitter.com/huportugues',
      lockPost: 'https://support.healthunlocked.com/article/36-turn-off-replying-on-posts',
    },
  },
  user: {
    en: {
      verify: 'https://support.healthunlocked.com/article/22-why-should-i-confirm-my-email-address',
    },
    es: {
      verify: 'https://support.healthunlocked.com/article/22-why-should-i-confirm-my-email-address',
    },
    pt: {
      verify: 'https://support.healthunlocked.com/article/22-why-should-i-confirm-my-email-address',
    },
  },
  //	Set cookie expire time in 1 year by default
  cookie: {
    expire: 365 * 24 * 60 * 60 * 1000,
  },
  collectionSize: {
    readNext: 5,
    trendingPosts: 5,
    popularPosts: 10, //Bigger by default so we do not need an extra fetch
    popularPostsVisitors: 5,
  },
  pageSize: {
    defaults: 30,
    activity: 30,
    communities: 30,
    members: 30,
    posts: 30,
    polls: 30,
    readNext: 30,
    relatedCommunities: 30,
    search: 20,
  },
  search: {
    showPrivateCommunities: false,
  },
  badges: {
    popular: {
      //TODO set a real value
      minResponses: 20,
    },
  },

  defaultProfileImage: configBuild.imagesPath + '/avatars/avatar_hidden_medium_200x200.jpg',
  defaultBannerImage: configBuild.assetPath + '/betelgeuse/img/gallery/default-banner_1170x250.png',

  apiSortMethods: [
    'newest',
    'active',
    'no-response',
    'popular',
    'pinned',
  ],
  apiSortFriendlyMethods: [
    i18n('Newest'),
    i18n('Recently Active'),
    i18n('Unanswered'),
    i18n('Popular'),
    i18n('Pinned'),
  ],

  api: {
    burst: {
      wait: 500, //waiting time in milliseconds before repeat a request to the API
      waitShort: 50,
    },
    search: {
      defaults: {
        start: 0, //first result index
        limit: 20, //page size
        lang: 'en',
        sortDate: false, //true= sort by relevance
      },
    },
    healthTerms: {
      batchSize: 45, //Grab health terms in batches of 45 to avoid hitting potential URL length limits for GET
    },
    dateFormat: 'YYYY-MM-DDT',
    maxFilesize: 5, //in MB
    roles: {
      admin: 1,
      restricted: 30,
      // org: 10,
      // volunteer: 682
    },
    minAge: 18,
    poll: {
      minChoices: 2,
    },
    postTypes: {
      POST: 4,
      QUESTION: 1,
      POLL: 6,
      POLL_CHOICE: 7,
      ANSWER: 2,
      COMMENT: 19,
    },
    communityWidgetTypes: {
      PINNED_POSTS: 1,
      EVENTS: 2,
      POLL: 3,
      CONTACT_US: 4,
      SUPPORT_US: 5,
      CAMPAIGN: 6,
    },
    communityTypes: {
      EDITORIAL: 8,
    },
  },
  text: {
    brief0: {
      length: 140,
    },
    brief: {
      length: 150,
    },
  },
  availableLanguages: [
    {short: 'en', long: 'English', locale: 'en_GB'},
    {short: 'es', long: 'Español', locale: 'es_ES'},
    {short: 'pt', long: 'Português', locale: 'pt_BR'},
  ],
  //BUILD language
  language: {short: 'en', long: 'English', locale: 'en_GB'},
  defaultLanguage: {short: 'en', long: 'English', locale: 'en_GB'},

  scrollPadding: 150,
  waitTillScroll: 1000, //milliseconds
  ux: {
    alertTimeout: 7000, //milliseconds
  },
  waitTillShowEmptyMsg: 1000, //in milliseconds
  minAge: 18,
  style: {
    //should match footer class height
    footerHeight: 200,
  },
  months: [
    i18n('January'),
    i18n('February'),
    i18n('March'),
    i18n('April'),
    i18n('May'),
    i18n('June'),
    i18n('July'),
    i18n('August'),
    i18n('September'),
    i18n('October'),
    i18n('November'),
    i18n('December'),
  ],
  threeCharMonths: [
    i18n('Jan'),
    i18n('Feb'),
    i18n('Mar'),
    i18n('Apr'),
    i18n('May'),
    i18n('Jun'),
    i18n('Jul'),
    i18n('Aug'),
    i18n('Sep'),
    i18n('Oct'),
    i18n('Nov'),
    i18n('Dec'),
  ],
  noPostCodeCountries: [
    'AE', 'AF', 'AG', 'AI', 'AL', 'AM', 'AN', 'AO', 'AQ', 'AS', 'AW', 'AZ', 'BA', 'BB', 'BF',
    'BH', 'BI', 'BJ', 'BL', 'BM', 'BN', 'BO', 'BQ', 'BS', 'BT', 'BV', 'BW', 'BY', 'BZ', 'CC',
    'CD', 'CF', 'CG', 'CI', 'CK', 'CL', 'CM', 'CN', 'CO', 'CR', 'CS', 'CU', 'CV', 'CW', 'CX',
    'CY', 'DJ', 'DM', 'EC', 'EE', 'EG', 'EH', 'ER', 'ET', 'FJ', 'FK', 'FM', 'GA', 'GD', 'GE',
    'GH', 'GI', 'GM', 'GN', 'GQ', 'GR', 'GS', 'GW', 'GY', 'HK', 'HM', 'HN', 'HT', 'ID', 'IE',
    'IL', 'IO', 'IQ', 'IR', 'JM', 'JO', 'KE', 'KG', 'KH', 'KI', 'KM', 'KN', 'KP', 'KR', 'KW',
    'KY', 'KZ', 'LA', 'LB', 'LC', 'LR', 'LS', 'LV', 'LY', 'MA', 'ME', 'MF', 'MG', 'ML', 'MM',
    'MN', 'MO', 'MR', 'MS', 'MT', 'MU', 'MV', 'MW', 'MZ', 'NA', 'NC', 'NE', 'NF', 'NG', 'NI',
    'NP', 'NR', 'NU', 'OM', 'PA', 'PE', 'PF', 'PG', 'PN', 'PS', 'PW', 'PY', 'QA', 'RS', 'RW',
    'SA', 'SB', 'SC', 'SD', 'SG', 'SH', 'SL', 'SN', 'SO', 'SR', 'SS', 'ST', 'SV', 'SX', 'SY',
    'SZ', 'TC', 'TD', 'TF', 'TG', 'TJ', 'TK', 'TL', 'TM', 'TN', 'TO', 'TT', 'TV', 'TW', 'TZ',
    'UA', 'UG', 'UM', 'UY', 'UZ', 'VA', 'VC', 'VE', 'VG', 'VN', 'VU', 'WF', 'WS', 'XK', 'YE',
    'ZM', 'ZW',
  ],
  signupContext: {
    element: {
      LINK: 'Link',
      USER_LINK: 'UserLink',
      AVATAR: 'Avatar',
      VOTE: 'Vote',
      FOLLOW: 'Follow',
      FACEBOOK: 'Facebook',
      EMAIL: 'Email',
      LOGIN: 'Login',
      LIKE: 'Like',
      SIGNUP: 'Signup',
      WRITE: 'Write',
      EDIT: 'Edit',
      REPLY: 'Reply',
      REPLY_HIDDEN_LINK: 'ReplyHiddenLink',
      REPLY_SUBMIT: 'SubmitReply',
      BUTTON: 'Button',
      FIND_OTHERS_LINK: 'FindOthersLink',
      TAKE_HEALTH_NEEDS_QUIZ_LINK: 'TakeHealthNeedsQuizLink',
      ASK_HEALTH_QUESTION_LINK: 'AskHealthQuestionLink',
      UNTRACKED: 'UNTRACKED',
    },
    section: {
      HEADER: 'Header',
      ABOVE_FOOTER: 'AboveFooter',
      CONVERSION: 'ConvBox',
      CONVERSION_UPPER: 'ConvBoxUpper',
      CONVERSION_LOWER: 'ConvBoxLower',
      CONVERSION_SIDEBAR: 'ConvBoxSidebar',
      CONVERSION_HIDDEN_RESP: 'ConvBoxReply',
      LOGIN_REDIRECT: 'LoginBox',
      BANNER: 'Banner',
      POST: 'Post',
      POSTS: 'Posts',
      REPLY: 'Reply',
      POST_REPLY: 'PostReply',
      POLL: 'Poll',
      POLLS: 'Polls',
      POLL_REPLY: 'PollReply',
      MOBILE_NAV: 'MobileNav',
      SEARCH_HIT: 'SearchHit',
      USER_LIST: 'UserList',
      RELATED_WIDGET: 'RelatedCommunity',
      COMMUNITY: 'Community',
      COMMUNITY_HOME_MEMBERS: 'CommunityHomeMembers',
      COMMUNITY_HOME_POST: 'CommunityHomePost',
      COMMUNITY_HOME_POLL: 'CommunityHomePoll',
      COMMUNITY_ABOUT: 'CommunityAbout',
      COMMUNITY_BOX: 'CommunityBox',
      COMMUNITY_MEMBERS: 'CommunityMembers',
      SIGNUP_PAGE: 'SignupPage',
      FLOATING_BOX: 'FloatingBox',
      VISITOR_MENU: 'VisitorMenu',
      UNTRACKED: 'UNTRACKED',
    },
  },
  regex: {
    // detect the expressions of the form @[n] with an integer
    MENTIONED_USERS_ID: /@\[([0-9]+)]/g,
    // detect emoticons
    // [8:;] - starts with any of these chars
    // ['-]{0,} - optionally has an extra char, like hyphen eg, :-D
    // (&#39;){0,1} - for smiley's with single quote, since single quote is encoded. eg, :'(
    // [dDpPoOxX|/\)\(] - followed by one of these charset: d,D,p,P,o,O,x,X,|,),(
    SMILEYS: /[8:;]['-]{0,}('){0,1}[dDpPoOxX|\/\)\(](?=$|\s)/g,
    // Found on https://daringfireball.net/2010/07/improved_regex_for_matching_urls
    /* eslint-disable */
    URL: /(?:\s|^)((?:(?:f|ht)tps?:\/\/(?:www\.)?|www\.)([-a-zA-Z0-9@:%_\+,'~#?;&\/\/=!()]+\.[-a-zA-Z0-9@:%_\+.,'~#?;&\/\/=!()]*[-a-zA-Z0-9@%_\+~'#&\/\/=(]))/g,
    YOUTUBE_URL: /(?:youtube\.com\/watch\?v=|youtu\.be\/)(.*)/,
    /* eslint-enable */
    BBCODE: /\[\/?(?:b|i|u)]/g,
    UNDESIRABLE_CHARACTERS: [
      { pattern: /\xa0/gi, replacement: ' ' },
    ],
  },
  whitelistURL: [
    'nhs.uk',
    'wikipedia.org',
    'healthunlocked.com',
  ],
};



// WEBPACK FOOTER //
// ./app/assets/js/config.js